import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import Loading from 'components/Loading/Loading';
import UserProfileForm from 'components/forms/UserProfileForm/UpdateUserProfileForm';
import FlashMessage from 'components/alerts/FlashMessage/FlashMessage';

import './style.css';

class UserProfileDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showProfileUpdateSuccess: false,
    };
  }

  handleProfileUpdateSuccess = () => {
    this.setState({ showProfileUpdateSuccess: true });
    setTimeout(() => {
      this.setState({ showProfileUpdateSuccess: false });
    }, 3000);
  }

  renderSuccessAlert() {
    return (
      <FlashMessage className="CustomerSuccess" alertType="success">
        You have successfully updated your profile
      </FlashMessage>
    );
  }

  render() {
    if (_.isEmpty(this.props.profile)) {
      return (
        <div className="UserProfileDetails">
          <Loading />
        </div>
      );
    }

    const { showProfileUpdateSuccess } = this.state;

    return (
      <div className="UserProfileDetails">
        {showProfileUpdateSuccess && this.renderSuccessAlert()}
        <div className="card">
          <div className="card-block">
            <div className="card">
              <div className="card-header bg-secondary">
                <h5 className="text-muted mb-0"> Profile </h5>
              </div>

              <div className="card-block row">
                {/* <div className="hidden-xs-up col-md-3 avatar mx-auto">
                  <img
                    className="rounded-circle img-fluid mb-3"
                    src={imageUrl}
                    alt={`${firstName}`}
                  />
                </div> */}

                <div className="col-12">
                  <UserProfileForm
                    handleProfileUpdateSuccess={this.handleProfileUpdateSuccess}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    profile: state.user.profile
  };
}

export default connect(mapStateToProps)(UserProfileDetails);



// WEBPACK FOOTER //
// ./src/pages/student/Profile/routes/Edit/index.js